// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"56f1dd6c","123":"16cbb146","453":"d855a71b"}[chunkId] + ".chunk.js";
};